// extracted by mini-css-extract-plugin
module.exports = {"container":"Config_container__9OQCe","divText":"Config_divText__2a_Hg","TextField":"Config_TextField__23T4F","buttonGroup":"Config_buttonGroup__2aqjA"};